var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMobilenotelistAmico(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 500 500",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "freepik--Floor--inject-6"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M412.31,256.39c90.23,49.73,90.7,130.36,1.06,180.09s-235.45,49.73-325.67,0S-3,306.12,86.63,256.38,322.08,206.65,412.31,256.39Z",
    style: {
      fill: "#f5f5f5"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Shadows--inject-6"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M135.75,392.53l16.58,9.63a8.25,8.25,0,0,0,8.32,0L295.43,323.8a2.76,2.76,0,0,0,0-4.77l-16.57-9.64a8.3,8.3,0,0,0-8.32,0L135.75,387.76A2.76,2.76,0,0,0,135.75,392.53Z",
    style: {
      fill: "#e6e6e6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M364.66,368.2c19.93,11.51,20,30.17.23,41.67s-52,11.51-71.95,0-20-30.16-.23-41.67S344.72,356.69,364.66,368.2Z",
    style: {
      fill: "#e6e6e6"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Plants--inject-6"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M121.71,321.12c-2.64-2.53-5.66-5.29-5.85-8.94-.17-3.25,2.22-6.3,5.26-7.48a12.15,12.15,0,0,1,9.46.72,25.55,25.55,0,0,1,7.58,6.07,60.72,60.72,0,0,1,14.31,53.07c-.26,1.23-.68,2.59-1.79,3.18-1.76.93-3.77-.71-5-2.3a36.78,36.78,0,0,1-5.86-11.6c-1.05-3.53-.58-7.44-1.91-10.77C134.67,334.89,128,327.12,121.71,321.12Z",
    style: {
      fill: "#0E7490"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M149.15,363h0a.7.7,0,0,1-.7-.7A69,69,0,0,0,122.61,309a.71.71,0,1,1,.87-1.11,70.46,70.46,0,0,1,26.37,54.38A.7.7,0,0,1,149.15,363Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M140.5,391c-4.45,1.43-10,.5-12.6-3.4-3-4.58-1.13-11.64-5.19-15.34-2.26-2.07-5.6-2.27-8.6-2.9s-6.35-2.28-6.8-5.32c-.59-4,4.36-7.37,3.66-11.38s-6.15-5.19-7.76-8.86c-1.47-3.35,1.13-7.41,4.57-8.65s7.27-.39,10.7.88,6.77,2.95,10.4,3.4c3.78.46,8.14-.28,10.92,2.32,3.71,3.47,1.59,10.09,4.46,14.28,1.92,2.8,5.54,3.78,8.31,5.75a13.3,13.3,0,0,1,5.5,10.93c-.09,4.61-2.52,7.94-6,10.59C148.38,386.08,145.07,389.48,140.5,391Z",
    style: {
      fill: "#0E7490"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M140.5,391c-4.45,1.43-10,.5-12.6-3.4-3-4.58-1.13-11.64-5.19-15.34-2.26-2.07-5.6-2.27-8.6-2.9s-6.35-2.28-6.8-5.32c-.59-4,4.36-7.37,3.66-11.38s-6.15-5.19-7.76-8.86c-1.47-3.35,1.13-7.41,4.57-8.65s7.27-.39,10.7.88,6.77,2.95,10.4,3.4c3.78.46,8.14-.28,10.92,2.32,3.71,3.47,1.59,10.09,4.46,14.28,1.92,2.8,5.54,3.78,8.31,5.75a13.3,13.3,0,0,1,5.5,10.93c-.09,4.61-2.52,7.94-6,10.59C148.38,386.08,145.07,389.48,140.5,391Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M138.5,359.44l-.06-.07c-.66-1-1.35-1.91-2.08-2.82a51,51,0,0,0-25.55-17,.7.7,0,1,0-.39,1.35,49.65,49.65,0,0,1,24.84,16.53c.2.24.37.51.57.76-8-2.92-16.09-1.26-20.42,2.23a.71.71,0,0,0-.11,1,.72.72,0,0,0,.55.26.66.66,0,0,0,.44-.16c4.29-3.45,13.14-5,21.17-1.1A49.67,49.67,0,0,1,146,385.26a.69.69,0,0,0,.7.66h0a.7.7,0,0,0,.66-.74A51.19,51.19,0,0,0,138.5,359.44Z",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Device--inject-6"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M287.76,44.39h0c-.9-3.18-7.34-9.21-13.75-9.08a5.56,5.56,0,0,0-1.8.35L147.71,106.49a11.79,11.79,0,0,0-4.79,5.13,11.93,11.93,0,0,0-1.23,5.22V386.17c0,6.86,7.91,13.41,15.33,10.26l0,0a2.82,2.82,0,0,0,.48-.19l124.52-71a11.92,11.92,0,0,0,6-10.34V45.68A2.86,2.86,0,0,0,287.76,44.39Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M159.05,145.31a6,6,0,0,1,3-5.18l115.6-65.77A3,3,0,0,1,282.12,77V294.12a6,6,0,0,1-3,5.18L163.51,365.18a3,3,0,0,1-4.46-2.59Z",
    style: {
      fill: "#0E7490"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M159.05,145.31a6,6,0,0,1,3-5.18l115.6-65.77A3,3,0,0,1,282.12,77V294.12a6,6,0,0,1-3,5.18L163.51,365.18a3,3,0,0,1-4.46-2.59Z",
    style: {
      fill: "#fff",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M141.69,116.84V386.17c0,6.86,7.91,13.41,15.33,10.26l0,0a3,3,0,0,1-4-2.78V124.29a11.84,11.84,0,0,1,2-6.58l-12.19-6.09A11.93,11.93,0,0,0,141.69,116.84Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M274,35.3a5.56,5.56,0,0,0-1.8.35L147.71,106.49a11.79,11.79,0,0,0-4.79,5.13l12.19,6.09a11.82,11.82,0,0,1,4-3.78L283.63,43.1a3,3,0,0,1,4.13,1.29h0C286.87,41.2,280.43,35.17,274,35.3Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M235.94,87.57c.87-.51,1.59-.11,1.6.89A3.56,3.56,0,0,1,236,91.22l-24.43,14.1c-.88.51-1.58.08-1.59-.92a3.47,3.47,0,0,1,1.58-2.73Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M205.23,105.3c.88-.51,1.58-.11,1.59.9a3.48,3.48,0,0,1-1.58,2.74c-.87.51-1.6.09-1.6-.91A3.5,3.5,0,0,1,205.23,105.3Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M220.87,85.52c1.75-1,3.16-.21,3.16,1.8a7,7,0,0,1-3.14,5.49c-1.75,1-3.19.18-3.2-1.83A7,7,0,0,1,220.87,85.52Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M220.88,339.07c3.56-2.06,6.43-.42,6.44,3.67a14.21,14.21,0,0,1-6.4,11.17c-3.56,2-6.51.37-6.52-3.72A14.22,14.22,0,0,1,220.88,339.07Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M211.23,121.63c1.53-.88,2.37-.32,2.37,1.5l0,5.92a4.67,4.67,0,0,1-2.35,4.22c-1.53.88-2.37.33-2.37-1.49l0-5.92A4.69,4.69,0,0,1,211.23,121.63Zm.83,8.44,0-6.16c0-.81-.31-.94-.8-.65a1.65,1.65,0,0,0-.81,1.58l0,6.16c0,.81.32.93.81.65a1.65,1.65,0,0,0,.8-1.58",
    style: {
      fill: "#0E7490"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "218.96 117.31 218.96 118.93 217.34 119.87 217.37 129.62 215.81 130.52 215.78 120.77 214.15 121.71 214.14 120.08 218.96 117.31",
    style: {
      fill: "#0E7490"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "223.88 114.46 223.88 116.09 221.2 117.64 221.21 120.81 223.34 119.57 223.35 121.2 221.21 122.44 221.22 125.77 223.91 124.22 223.91 125.84 219.67 128.29 219.64 116.91 223.88 114.46",
    style: {
      fill: "#0E7490"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "228.59 111.74 228.62 121.5 231.18 120.01 231.19 121.64 227.07 124.02 227.04 112.64 228.59 111.74",
    style: {
      fill: "#0E7490"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "233.39 108.97 233.42 120.35 231.86 121.25 231.83 109.87 233.39 108.97",
    style: {
      fill: "#0E7490"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M236.61,107c1.52-.87,2.3-.28,2.3,1.54v.36l-1.47.84v-.47c0-.81-.28-1-.78-.67a1.61,1.61,0,0,0-.77,1.57c0,.83.31,1.26,1.34,1.7a2.43,2.43,0,0,1,1.72,2.57,4.62,4.62,0,0,1-2.32,4.21c-1.53.88-2.32.3-2.32-1.53v-.7l1.48-.85v.82c0,.81.31.93.8.64a1.63,1.63,0,0,0,.81-1.57c0-.83-.32-1.27-1.34-1.7a2.43,2.43,0,0,1-1.72-2.58A4.57,4.57,0,0,1,236.61,107Z",
    style: {
      fill: "#0E7490"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "244.17 102.75 244.17 104.37 242.54 105.31 242.57 115.07 241.02 115.96 240.99 106.21 239.36 107.15 239.36 105.53 244.17 102.75",
    style: {
      fill: "#0E7490"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M229.66,141.83c1.15-.66,1.78-.24,1.78,1.13v4.43a3.5,3.5,0,0,1-1.76,3.17c-1.15.67-1.78.25-1.78-1.12l0-4.44A3.54,3.54,0,0,1,229.66,141.83Zm.63,6.32,0-4.61c0-.61-.23-.7-.6-.49a1.24,1.24,0,0,0-.61,1.19l0,4.61c0,.61.23.71.6.49a1.25,1.25,0,0,0,.61-1.19",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M229.67,143.05c.37-.21.6-.12.6.49l0,4.61a1.25,1.25,0,0,1-.61,1.19c-.37.22-.6.12-.6-.49l0-4.61A1.24,1.24,0,0,1,229.67,143.05Z",
    style: {
      fill: "#0E7490"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M219.42,149.06c.41-.24.59-.07.59.54v.84a1.33,1.33,0,0,1-.69,1.31l-.46.27v-2.63Z",
    style: {
      fill: "#0E7490"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M215.16,151.43c.37-.22.6-.12.6.49l0,4.61a1.24,1.24,0,0,1-.61,1.19c-.36.21-.6.11-.6-.49l0-4.61A1.25,1.25,0,0,1,215.16,151.43Z",
    style: {
      fill: "#0E7490"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "222.75 176.32 222.76 177.53 220.75 178.69 220.75 181.07 222.35 180.15 222.35 181.37 220.75 182.29 220.76 184.79 222.77 183.63 222.78 184.85 219.59 186.69 219.57 178.16 222.75 176.32",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "226.75 174.01 226.75 175.23 225.53 175.93 225.55 183.25 224.38 183.92 224.36 176.6 223.14 177.31 223.13 176.1 226.75 174.01",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "228.42 173.04 228.44 181.58 227.28 182.25 227.25 173.72 228.42 173.04",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "232.97 170.42 232.99 178.95 231.79 179.65 230.34 174.29 230.32 174.3 230.34 180.48 229.28 181.09 229.26 172.56 230.72 171.72 231.92 176.14 231.94 176.13 231.92 171.02 232.97 170.42",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M235.45,168.88c1.14-.66,1.74-.22,1.74,1.15v.83l-1.1.63v-.91c0-.61-.24-.7-.61-.49a1.25,1.25,0,0,0-.6,1.19v4.61c0,.61.24.69.61.48a1.22,1.22,0,0,0,.6-1.18v-1.57l-.54.31V172.7l1.64-.94v2.71a3.43,3.43,0,0,1-1.73,3.15c-1.14.66-1.74.22-1.75-1.14V172A3.48,3.48,0,0,1,235.45,168.88Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M224.75,206.68c.36-.21.6-.11.6.5l0,4.61a1.26,1.26,0,0,1-.61,1.19c-.37.21-.6.12-.6-.5l0-4.61A1.25,1.25,0,0,1,224.75,206.68Z",
    style: {
      fill: "#0E7490"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M218.89,208.85c1.15-.66,1.78-.25,1.78,1.12l0,4.44a3.55,3.55,0,0,1-1.77,3.17c-1.15.66-1.78.23-1.78-1.13V212A3.49,3.49,0,0,1,218.89,208.85Zm.62,6.31v-4.61c0-.6-.23-.7-.61-.49a1.28,1.28,0,0,0-.6,1.19l0,4.61c0,.62.23.71.6.49a1.2,1.2,0,0,0,.6-1.19",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M218.89,210.06c.38-.21.61-.11.61.49v4.61a1.2,1.2,0,0,1-.6,1.19c-.37.22-.6.13-.6-.49l0-4.61A1.28,1.28,0,0,1,218.89,210.06Z",
    style: {
      fill: "#0E7490"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M205.1,216.81c1.15-.66,1.74-.23,1.74,1.14v.83l-1.1.63v-.91c0-.61-.23-.71-.6-.49a1.23,1.23,0,0,0-.61,1.19l0,4.61c0,.61.23.7.6.48a1.23,1.23,0,0,0,.61-1.18v-1.58l-.53.31v-1.21l1.64-.95v2.71a3.47,3.47,0,0,1-1.73,3.15c-1.15.66-1.75.22-1.76-1.14V220A3.45,3.45,0,0,1,205.1,216.81Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "216.71 210.2 216.71 211.43 215.49 212.13 215.51 219.45 214.34 220.12 214.32 212.8 213.1 213.51 213.1 212.29 216.71 210.2",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M224.74,205.47c1.15-.66,1.77-.25,1.78,1.12V211a3.53,3.53,0,0,1-1.76,3.17c-1.15.66-1.78.24-1.79-1.12v-4.44A3.53,3.53,0,0,1,224.74,205.47Zm.63,6.32,0-4.61c0-.61-.24-.71-.6-.5a1.25,1.25,0,0,0-.61,1.19l0,4.61c0,.62.23.71.6.5a1.26,1.26,0,0,0,.61-1.19",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "234.01 200.22 234.01 201.44 232.09 202.55 232.09 205.12 233.6 204.25 233.61 205.47 232.1 206.34 232.11 209.86 230.94 210.54 230.92 202 234.01 200.22",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "235.73 199.22 235.76 207.76 234.59 208.43 234.57 199.89 235.73 199.22",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M238.23,197.68c1.14-.66,1.74-.22,1.74,1.14v.83l-1.1.64v-.92c0-.6-.24-.7-.61-.49a1.24,1.24,0,0,0-.6,1.19v4.61c0,.61.24.7.61.48a1.22,1.22,0,0,0,.6-1.18v-1.21l1.1-.64v1.14a3.42,3.42,0,0,1-1.73,3.14c-1.14.66-1.74.22-1.74-1.14v-4.44A3.43,3.43,0,0,1,238.23,197.68Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "243.86 194.53 243.87 195.75 241.85 196.91 241.85 199.29 243.46 198.37 243.46 199.58 241.86 200.5 241.87 203.01 243.88 201.84 243.89 203.06 240.7 204.9 240.68 196.36 243.86 194.53",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "231.36 232.14 231.37 233.36 230.15 234.06 230.17 241.38 229 242.06 228.98 234.74 227.76 235.44 227.76 234.22 231.36 232.14",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M234.06,230.58l1.21,7.86-1.18.68-.2-1.44-1.43.83-.2,1.66-1.07.62,1.16-9.22Zm-1.46,6.69,1.13-.66-.57-4h0l-.54,4.64",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "233.14 232.63 233.16 232.62 233.73 236.62 232.6 237.26 233.14 232.63",
    style: {
      fill: "#0E7490"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M210.06,244.34c1.15-.66,1.78-.25,1.79,1.12v4.44a3.54,3.54,0,0,1-1.77,3.17c-1.15.66-1.77.24-1.78-1.12v-4.44A3.52,3.52,0,0,1,210.06,244.34Zm.63,6.32,0-4.61c0-.61-.23-.71-.6-.49a1.25,1.25,0,0,0-.61,1.19l0,4.61c0,.61.24.7.6.49a1.24,1.24,0,0,0,.61-1.19",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M210.07,245.56c.37-.22.6-.12.6.49l0,4.61a1.24,1.24,0,0,1-.61,1.19c-.36.21-.6.12-.6-.49l0-4.61A1.25,1.25,0,0,1,210.07,245.56Z",
    style: {
      fill: "#0E7490"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "217.51 240.14 217.51 241.36 216.29 242.07 216.31 249.38 215.14 250.06 215.12 242.74 213.9 243.44 213.9 242.22 217.51 240.14",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "221.7 237.72 221.72 246.26 220.53 246.95 220.52 243.29 219.19 244.05 219.21 247.71 218.04 248.38 218.02 239.84 219.18 239.17 219.19 242.83 220.52 242.07 220.51 238.41 221.7 237.72",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "225.73 235.39 225.73 236.62 223.72 237.78 223.72 240.16 225.32 239.23 225.33 240.45 223.73 241.37 223.74 243.87 225.75 242.71 225.75 243.93 222.57 245.77 222.54 237.23 225.73 235.39",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M237.36,228.58c1.13-.65,1.72-.21,1.72,1.15V230l-1.1.64v-.36c0-.61-.22-.71-.59-.5a1.22,1.22,0,0,0-.58,1.18c0,.62.24.95,1,1.28a1.82,1.82,0,0,1,1.29,1.93,3.46,3.46,0,0,1-1.74,3.15c-1.15.66-1.74.22-1.74-1.14v-.53l1.11-.63v.6c0,.62.24.7.61.49a1.24,1.24,0,0,0,.6-1.19c0-.62-.23-.95-1-1.27a1.82,1.82,0,0,1-1.29-1.93A3.43,3.43,0,0,1,237.36,228.58Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "243.62 225.06 242 229.81 243.64 233.6 242.44 234.29 241.3 231.54 240.94 232.53 240.95 235.16 239.78 235.83 239.76 227.29 240.92 226.62 240.94 230.31 240.95 230.3 242.45 225.74 243.62 225.06",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M188.63,254.18c1-.6,1.87-.12,1.87,1.07l0,9.32a4.13,4.13,0,0,1-1.87,3.24l-8.43,4.87c-1,.59-1.88.11-1.88-1.07l0-9.33a4.12,4.12,0,0,1,1.87-3.23Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M188.54,223.83c.69-.4,1.29-.32,1.62.13l-6.35,10.29-2.07-1.3-3.17.85,5.4,4.88,6.45-12.25,0,7.8a4.11,4.11,0,0,1-1.86,3.23l-8.44,4.87c-1,.59-1.87.11-1.88-1.07l0-9.33a4.1,4.1,0,0,1,1.86-3.23Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M253,286.1a1.89,1.89,0,0,1,1.88-.2c1,.6,1,2.53,0,4.32a5.4,5.4,0,0,1-1.87,2,1.89,1.89,0,0,1-1.88.19c-1-.59-1-2.52,0-4.31A5.32,5.32,0,0,1,253,286.1Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M259.7,291.62c.31.19.31.78,0,1.32a1.61,1.61,0,0,1-.57.61.55.55,0,0,1-.57.05l-3.13-1.77a8.15,8.15,0,0,1-2.39,2.23,3,3,0,0,1-3,.3c-1.67-.95-1.68-4.07,0-6.95a8.71,8.71,0,0,1,3-3.17,3.08,3.08,0,0,1,3-.32c1.48.84,1.66,3.37.53,5.93Zm-4.79-1.4c1-1.79,1-3.72,0-4.32a1.89,1.89,0,0,0-1.88.2,5.32,5.32,0,0,0-1.87,2c-1,1.79-1,3.72,0,4.31a1.89,1.89,0,0,0,1.88-.19,5.4,5.4,0,0,0,1.87-2",
    style: {
      fill: "#0E7490"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M254.81,278.65c5.5-3.17,10-.62,10,5.7s-4.43,14-9.92,17.18-10,.62-10-5.69S249.32,281.82,254.81,278.65Zm4.89,14.29c.31-.54.31-1.13,0-1.32l-3.13-1.77c1.13-2.56.95-5.09-.53-5.93a3.08,3.08,0,0,0-3,.32,8.71,8.71,0,0,0-3,3.17c-1.66,2.88-1.65,6,0,6.95a3,3,0,0,0,3-.3,8.15,8.15,0,0,0,2.39-2.23l3.13,1.77a.55.55,0,0,0,.57-.05,1.61,1.61,0,0,0,.57-.61",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "195.5 216.78 190.42 226.43 183.97 238.68 178.57 233.8 181.74 232.95 183.81 234.25 190.16 223.96 193.09 219.22 195.5 216.78",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "230.35 202.33 230.35 203.55 228.44 204.66 228.45 207.22 229.95 206.35 229.95 207.58 228.45 208.44 228.46 211.97 227.29 212.65 227.26 204.11 230.35 202.33",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "195.42 186.11 190.34 195.76 183.88 208.01 178.49 203.12 181.65 202.28 183.72 203.57 189.95 193.48 193 188.54 195.42 186.11",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M188.45,193.48a1.21,1.21,0,0,1,1.5,0l-6.23,10.09-2.07-1.29-3.16.84,5.39,4.89,6.45-12.25,0,8.11a4.12,4.12,0,0,1-1.87,3.24L180.06,212c-1,.6-1.88.12-1.88-1.08l0-9.32a4.15,4.15,0,0,1,1.87-3.23Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "212.89 151.61 212.09 160.62 210.54 161.51 210.12 157.21 209.7 162 208.09 162.93 207.24 154.88 208.37 154.22 209.01 160.6 209.56 153.53 210.69 152.88 211.28 159.33 211.88 152.2 212.89 151.61",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M215.15,150.21c1.15-.67,1.78-.25,1.79,1.12v4.43a3.54,3.54,0,0,1-1.77,3.18c-1.15.66-1.77.24-1.78-1.13v-4.43A3.52,3.52,0,0,1,215.15,150.21Zm.63,6.32,0-4.61c0-.61-.23-.71-.6-.49a1.25,1.25,0,0,0-.61,1.19l0,4.61c0,.6.24.7.6.49a1.24,1.24,0,0,0,.61-1.19",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M221.2,154.33a2.5,2.5,0,0,0,.13.95l-1.19.69a2.54,2.54,0,0,1-.1-1v-1.33c0-.8-.24-1-.77-.65l-.41.23v3.48l-1.16.67,0-8.53,1.77-1c1.2-.7,1.72-.35,1.73,1v.68a3.09,3.09,0,0,1-.76,2.16v0c.59-.06.78.47.78,1.36ZM220,150.44v-.84c0-.61-.18-.78-.59-.54l-.57.33V152l.46-.27a1.33,1.33,0,0,0,.69-1.31",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "225.81 144.15 224.2 148.9 225.84 152.69 224.63 153.38 223.49 150.63 223.13 151.62 223.14 154.24 221.97 154.92 221.95 146.38 223.11 145.71 223.12 149.41 223.15 149.39 224.64 144.83 225.81 144.15",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "239.68 136.15 239.68 137.36 238.46 138.07 238.48 145.38 237.32 146.06 237.29 138.74 236.07 139.45 236.07 138.23 239.68 136.15",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "214.82 180.9 214.84 189.43 213.74 190.07 213.72 183.95 212.93 190.53 211.83 191.17 210.96 185.62 210.96 191.67 209.94 192.26 209.92 183.73 211.54 182.79 212.41 188.36 213.2 181.84 214.82 180.9",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M235.62,138.49l0,6.5a3.47,3.47,0,0,1-1.74,3.15c-1.15.66-1.74.23-1.75-1.14l0-6.5,1.17-.67,0,6.59c0,.6.24.69.61.47a1.22,1.22,0,0,0,.6-1.17l0-6.59Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M268.16,113.71c2-1.13,3.54-.22,3.55,2l0,12.2a7.73,7.73,0,0,1-3.52,6.1l-89.51,51.68c-2,1.13-3.54.23-3.55-2l0-12.2a7.75,7.75,0,0,1,3.52-6.1l15.93-9.2-1.67,1.68L189.73,163a1.32,1.32,0,0,0-1.36.12L179.93,168a4.07,4.07,0,0,0-1.86,3.23l0,9.32c0,1.19.85,1.66,1.88,1.07l8.44-4.87a4.1,4.1,0,0,0,1.86-3.23l0-8.44,4.83-9.19Zm-56.07,46.91.8-9-1,.59-.57,7.12-.61-6.44-1.13.66-.53,7.05-.66-6.37-1.13.66.85,8.05,1.61-.93.4-4.78.44,4.29,1.55-.89m13.75-7.94-1.64-3.78,1.61-4.75-1.17.68-1.49,4.56,0,0v-3.7l-1.16.68,0,8.53,1.17-.68v-2.62l.36-1,1.14,2.75,1.21-.7m5.61-5.29V143c0-1.37-.63-1.79-1.78-1.13a3.54,3.54,0,0,0-1.77,3.17l0,4.44c0,1.37.63,1.79,1.78,1.12a3.5,3.5,0,0,0,1.76-3.17M217,155.76v-4.43c0-1.37-.64-1.79-1.79-1.12a3.52,3.52,0,0,0-1.76,3.17v4.43c0,1.37.63,1.79,1.78,1.13a3.54,3.54,0,0,0,1.77-3.18m3.19.21,1.19-.69a2.5,2.5,0,0,1-.13-.95V153c0-.89-.19-1.42-.78-1.36v0a3.09,3.09,0,0,0,.76-2.16v-.68c0-1.31-.53-1.66-1.73-1l-1.77,1,0,8.53,1.16-.67v-3.48l.41-.23c.53-.31.76-.15.77.65V155a2.54,2.54,0,0,0,.1,1m19.54-18.61v-1.21l-3.61,2.08v1.22l1.22-.71,0,7.32,1.16-.68,0-7.31,1.22-.71m-4,7.63,0-6.5-1.11.64,0,6.59a1.22,1.22,0,0,1-.6,1.17c-.37.22-.61.13-.61-.47l0-6.59-1.17.67,0,6.5c0,1.37.6,1.8,1.75,1.14a3.47,3.47,0,0,0,1.74-3.15",
    style: {
      fill: "#0E7490"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "207.88 123.7 207.91 135.08 206.31 136 204.38 128.87 204.35 128.88 204.38 137.12 202.98 137.93 202.94 126.55 204.89 125.42 206.48 131.33 206.51 131.31 206.49 124.5 207.88 123.7",
    style: {
      fill: "#0E7490"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M223.85,296.27c.78-.45,1.42-.09,1.42.81l0,8.54,7.43-4.29c.78-.45,1.42-.09,1.42.81a3.11,3.11,0,0,1-1.41,2.44l-7.43,4.29,0,8.53a3.09,3.09,0,0,1-1.41,2.44c-.78.46-1.42.09-1.42-.8l0-8.54-7.43,4.29c-.79.45-1.42.09-1.42-.81a3.08,3.08,0,0,1,1.41-2.44l7.43-4.29,0-8.54A3.11,3.11,0,0,1,223.85,296.27Z",
    style: {
      fill: "#0E7490"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M223.84,292.09c7.63-4.41,13.84-.87,13.86,7.9s-6.14,19.45-13.77,23.86-13.84.86-13.86-7.9S216.21,296.5,223.84,292.09Zm8.89,12.49a3.11,3.11,0,0,0,1.41-2.44c0-.9-.64-1.26-1.42-.81l-7.43,4.29,0-8.54c0-.9-.64-1.26-1.42-.81a3.11,3.11,0,0,0-1.41,2.44l0,8.54L215,311.54a3.08,3.08,0,0,0-1.41,2.44c0,.9.63,1.26,1.42.81l7.43-4.29,0,8.54c0,.89.64,1.26,1.42.8a3.09,3.09,0,0,0,1.41-2.44l0-8.53,7.43-4.29",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "192.9 318.45 194.86 321.87 199.23 320.08 196.08 325.44 196.84 330.01 192.93 329.9 189.03 334.51 189.76 329.09 186.59 327.38 190.96 324.12 192.9 318.45",
    style: {
      fill: "#0E7490"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M192.88,314.41c5.5-3.18,10-.63,10,5.69s-4.42,14-9.92,17.19-10,.62-10-5.69S187.39,317.58,192.88,314.41Zm4,15.6-.76-4.57,3.15-5.36-4.37,1.79-2-3.42L191,324.12l-4.37,3.26,3.17,1.71-.73,5.42,3.9-4.61,3.91.11",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "237.66 258.9 237.66 260.13 235.64 261.29 235.65 263.67 237.25 262.74 237.25 263.96 235.65 264.89 235.66 267.38 237.68 266.22 237.68 267.44 234.5 269.28 234.47 260.74 237.66 258.9",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "233.62 261.23 233.64 269.77 232.54 270.41 232.52 264.28 231.73 270.87 230.63 271.51 229.77 265.96 229.74 265.98 229.76 272.01 228.74 272.6 228.72 264.06 230.34 263.13 231.21 268.7 232 262.17 233.62 261.23",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M226.2,266.64c.38-.21.61-.12.61.49v4.61a1.21,1.21,0,0,1-.6,1.19c-.37.22-.6.12-.61-.49v-4.61A1.25,1.25,0,0,1,226.2,266.64Z",
    style: {
      fill: "#0E7490"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M226.2,265.42c1.15-.66,1.78-.24,1.78,1.12l0,4.44a3.53,3.53,0,0,1-1.77,3.17c-1.15.66-1.78.25-1.78-1.12v-4.44A3.49,3.49,0,0,1,226.2,265.42Zm.62,6.32v-4.61c0-.61-.23-.7-.61-.49a1.25,1.25,0,0,0-.6,1.19v4.61c0,.61.24.71.61.49a1.21,1.21,0,0,0,.6-1.19",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "223.68 266.97 223.7 275.51 222.51 276.2 222.5 272.54 221.18 273.3 221.19 276.96 220.02 277.64 219.99 269.1 221.16 268.42 221.18 272.08 222.5 271.32 222.49 267.66 223.68 266.97",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M215.82,271.41c1.15-.66,1.78-.24,1.78,1.12l0,4.44a3.53,3.53,0,0,1-1.77,3.17c-1.15.66-1.78.25-1.78-1.12v-4.44A3.51,3.51,0,0,1,215.82,271.41Zm.63,6.32,0-4.6c0-.62-.23-.71-.6-.5a1.27,1.27,0,0,0-.61,1.2l0,4.6c0,.61.23.71.6.5a1.26,1.26,0,0,0,.61-1.2",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M215.83,272.63c.37-.21.6-.12.6.5l0,4.6a1.26,1.26,0,0,1-.61,1.2c-.37.21-.6.11-.6-.5l0-4.6A1.27,1.27,0,0,1,215.83,272.63Z",
    style: {
      fill: "#0E7490"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M211.65,273.82c1.15-.66,1.75-.22,1.75,1.14v.83l-1.11.64v-.91c0-.62-.23-.71-.6-.5a1.24,1.24,0,0,0-.6,1.19v4.61c0,.61.24.69.61.48a1.24,1.24,0,0,0,.6-1.18v-1.57l-.53.31v-1.22l1.64-.95v2.71a3.47,3.47,0,0,1-1.74,3.15c-1.15.66-1.74.23-1.75-1.14V277A3.47,3.47,0,0,1,211.65,273.82Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M205.89,248.07c.37-.21.59-.12.59.48l0,4.45a1.2,1.2,0,0,1-.59,1.16l-.66.38,0-6.09Z",
    style: {
      fill: "#0E7490"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M205.91,246.84c1.16-.68,1.74-.26,1.74,1.1v4.32a3.35,3.35,0,0,1-1.73,3.11l-1.85,1.07,0-8.54Zm.59,6.16,0-4.45c0-.6-.22-.69-.59-.48l-.66.38,0,6.09.66-.38a1.2,1.2,0,0,0,.59-1.16",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M188.71,284.52c1-.59,1.88-.11,1.88,1.07l0,9.33a4.12,4.12,0,0,1-1.87,3.23L180.31,303c-1,.6-1.87.12-1.87-1.07l0-9.33a4.12,4.12,0,0,1,1.87-3.23Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M268.5,235.1c2-1.13,3.54-.22,3.55,2l0,12.19a7.74,7.74,0,0,1-3.52,6.11l-89.5,51.68c-2,1.12-3.55.22-3.55-2l0-12.19a7.77,7.77,0,0,1,3.53-6.12Zm-77.88,59.82,0-9.33c0-1.18-.85-1.66-1.88-1.07l-8.43,4.87a4.12,4.12,0,0,0-1.87,3.23l0,9.33c0,1.19.84,1.67,1.87,1.07l8.44-4.87a4.12,4.12,0,0,0,1.87-3.23m43-25.15,0-8.54-1.63.94-.76,6.52-.89-5.56-1.62.93,0,8.54,1-.59,0-6,0,0,.86,5.55,1.1-.64.77-6.58,0,6.12,1.1-.64m-9.94,5.74,0-8.54-1.19.69v3.66l-1.33.76v-3.66l-1.17.68,0,8.54,1.17-.68V273.3l1.32-.76v3.66l1.19-.69M217.62,277l0-4.44c0-1.36-.63-1.78-1.78-1.12a3.51,3.51,0,0,0-1.76,3.17V279c0,1.37.63,1.78,1.78,1.12a3.53,3.53,0,0,0,1.77-3.17M228,271l0-4.44c0-1.36-.63-1.78-1.78-1.12a3.49,3.49,0,0,0-1.76,3.17V273c0,1.37.63,1.78,1.78,1.12A3.53,3.53,0,0,0,228,271m-14.59,4.81V275c0-1.36-.6-1.8-1.75-1.14a3.47,3.47,0,0,0-1.73,3.15v4.44c0,1.37.6,1.8,1.75,1.14a3.47,3.47,0,0,0,1.74-3.15v-2.71l-1.64.95v1.22l.53-.31v1.57a1.24,1.24,0,0,1-.6,1.18c-.37.21-.61.13-.61-.48l0-4.61a1.26,1.26,0,0,1,.61-1.19c.37-.21.6-.12.6.5v.91l1.11-.64m24.25-15.67V258.9l-3.18,1.84,0,8.54,3.18-1.84v-1.22l-2,1.16v-2.49l1.6-.93v-1.22l-1.6.93v-2.38l2-1.17",
    style: {
      fill: "#0E7490"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M209.27,214.4c1.15-.66,1.77-.24,1.78,1.12V220a3.52,3.52,0,0,1-1.76,3.17c-1.15.66-1.78.24-1.79-1.12v-4.44A3.51,3.51,0,0,1,209.27,214.4Zm.62,6.32v-4.61c0-.61-.24-.71-.61-.49a1.24,1.24,0,0,0-.6,1.19v4.61c0,.61.24.71.61.49a1.23,1.23,0,0,0,.6-1.19",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M209.27,215.62c.37-.22.61-.12.61.49v4.61a1.23,1.23,0,0,1-.6,1.19c-.37.22-.6.12-.61-.49v-4.61A1.24,1.24,0,0,1,209.27,215.62Z",
    style: {
      fill: "#0E7490"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M268.42,204.75c1.95-1.13,3.54-.22,3.54,2L272,219a7.79,7.79,0,0,1-3.52,6.11L179,276.76c-1.95,1.13-3.54.22-3.55-2l0-12.19a7.8,7.8,0,0,1,3.53-6.11Zm-77.89,59.82,0-9.32c0-1.19-.84-1.67-1.87-1.07l-8.44,4.87a4.12,4.12,0,0,0-1.87,3.23l0,9.33c0,1.18.85,1.66,1.88,1.07l8.43-4.87a4.13,4.13,0,0,0,1.87-3.24m43.56-25.45,1.18-.68-1.21-7.86-1.71,1-1.16,9.22,1.07-.62.2-1.66,1.43-.83.2,1.44m9.55-5.52L242,229.81l1.62-4.75-1.17.68L241,230.3h0v-3.69l-1.16.67,0,8.54,1.17-.67v-2.63l.36-1,1.14,2.74,1.2-.69m-21.92,12.66,0-8.54-1.19.69v3.66l-1.33.76v-3.66l-1.16.67,0,8.54,1.17-.67v-3.66l1.32-.76V247l1.19-.69m-9.86,3.64v-4.44c0-1.37-.64-1.78-1.79-1.12a3.52,3.52,0,0,0-1.76,3.17V252c0,1.36.63,1.78,1.78,1.12a3.54,3.54,0,0,0,1.77-3.17m5.65-8.54v-1.22l-3.61,2.08v1.23l1.22-.71,0,7.32,1.17-.68,0-7.31,1.22-.71m12.66,0,0-7.32,1.21-.7v-1.22l-3.6,2.08v1.22l1.22-.7,0,7.32,1.17-.68m-22.51,10.88v-4.32c0-1.36-.58-1.78-1.74-1.1l-1.85,1.06,0,8.54,1.85-1.07a3.35,3.35,0,0,0,1.73-3.11m29.71-14.94a3.46,3.46,0,0,0,1.74-3.15,1.82,1.82,0,0,0-1.29-1.93c-.77-.33-1-.66-1-1.28a1.22,1.22,0,0,1,.58-1.18c.37-.21.59-.11.59.5v.36l1.1-.64v-.27c0-1.36-.59-1.8-1.72-1.15a3.43,3.43,0,0,0-1.71,3.14,1.82,1.82,0,0,0,1.29,1.93c.77.32,1,.65,1,1.27a1.24,1.24,0,0,1-.6,1.19c-.37.21-.61.13-.61-.49V235l-1.11.63v.53c0,1.36.59,1.8,1.74,1.14m-11.64-.7v-1.23l-3.19,1.84,0,8.54,3.18-1.84v-1.22l-2,1.16v-2.5l1.6-.92v-1.22l-1.6.92v-2.37l2-1.16",
    style: {
      fill: "#0E7490"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "218.85 178.57 218.85 179.78 216.84 180.95 216.84 183.33 218.45 182.4 218.45 183.62 216.84 184.55 216.85 187.05 218.87 185.89 218.87 187.1 215.69 188.94 215.67 180.41 218.85 178.57",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M268.33,174.4c2-1.12,3.54-.21,3.55,2l0,12.2a7.78,7.78,0,0,1-3.52,6.11l-89.51,51.67c-1.95,1.13-3.54.22-3.55-2l0-12.2a7.76,7.76,0,0,1,3.53-6.11Zm-77.91,52,5.08-9.66-2.41,2.45L190.16,224c-.33-.45-.93-.53-1.62-.13l-8.44,4.87a4.1,4.1,0,0,0-1.86,3.23l0,9.33c0,1.18.85,1.66,1.88,1.07l8.44-4.87a4.11,4.11,0,0,0,1.86-3.23l0-7.8M211.06,220v-4.44c0-1.36-.63-1.78-1.78-1.12a3.51,3.51,0,0,0-1.77,3.17V222c0,1.36.64,1.78,1.79,1.12a3.52,3.52,0,0,0,1.76-3.17M226.53,211v-4.44c0-1.37-.63-1.78-1.78-1.12a3.53,3.53,0,0,0-1.77,3.17v4.44c0,1.36.64,1.78,1.79,1.12a3.53,3.53,0,0,0,1.76-3.17m-5.84,3.38,0-4.44c0-1.37-.63-1.78-1.78-1.12a3.49,3.49,0,0,0-1.76,3.16v4.44c0,1.36.63,1.79,1.78,1.13a3.55,3.55,0,0,0,1.77-3.17m-4-3V210.2l-3.61,2.09v1.22l1.22-.71,0,7.32,1.17-.67,0-7.32,1.22-.7m-9.86,7.35V218c0-1.37-.59-1.8-1.74-1.14a3.45,3.45,0,0,0-1.74,3.15v4.44c0,1.36.61,1.8,1.76,1.14a3.47,3.47,0,0,0,1.73-3.15v-2.71l-1.64.95v1.21l.53-.31v1.58a1.23,1.23,0,0,1-.61,1.18c-.37.22-.6.13-.6-.48l0-4.61a1.23,1.23,0,0,1,.61-1.19c.37-.22.6-.12.6.49v.91l1.1-.63M240,199.65v-.83c0-1.36-.6-1.8-1.74-1.14a3.43,3.43,0,0,0-1.73,3.15v4.44c0,1.36.6,1.8,1.74,1.14a3.42,3.42,0,0,0,1.73-3.14v-1.14l-1.1.64V204a1.22,1.22,0,0,1-.6,1.18c-.37.22-.6.13-.61-.48v-4.61a1.24,1.24,0,0,1,.6-1.19c.37-.21.61-.12.61.49v.92l1.1-.64m3.9-3.9v-1.22l-3.18,1.83,0,8.54,3.19-1.84v-1.22l-2,1.17v-2.5l1.6-.93v-1.22l-1.61.93v-2.38l2-1.16m-13.51,7.8v-1.22l-3.09,1.78,0,8.54,1.17-.68v-3.53l1.5-.86v-1.23l-1.5.87v-2.57l1.92-1.1m3.65-2.11v-1.22L230.92,202l0,8.54,1.17-.68v-3.52l1.51-.87v-1.23l-1.51.88v-2.57l1.92-1.11m1.75,6.32,0-8.54-1.16.67,0,8.54,1.17-.67",
    style: {
      fill: "#0E7490"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M268.25,144.06c1.95-1.13,3.54-.22,3.54,2l0,12.2a7.76,7.76,0,0,1-3.53,6.1l-89.5,51.68c-2,1.13-3.55.23-3.55-2l0-12.2a7.82,7.82,0,0,1,3.53-6.11l16.68-9.62L193,188.54,190,193.48a1.21,1.21,0,0,0-1.5,0L180,198.35a4.15,4.15,0,0,0-1.87,3.23l0,9.32c0,1.2.84,1.68,1.88,1.08l8.43-4.87a4.14,4.14,0,0,0,1.87-3.24l0-8.11,5.09-9.65Zm-53.41,45.37,0-8.53-1.62.93-.78,6.52-.88-5.56-1.62.94,0,8.53,1-.59,0-6,.89,5.54,1.1-.64.77-6.57,0,6.11,1.1-.64M233,179l0-8.53-1.05.6,0,5.11h0l-1.2-4.43-1.46.85,0,8.53,1.05-.61V174.3h0l1.45,5.36,1.2-.7m-6.24-3.72V174l-3.61,2.09v1.21l1.22-.7,0,7.31,1.17-.67,0-7.32,1.22-.7m10.44-4.37V170c0-1.37-.6-1.81-1.74-1.15a3.48,3.48,0,0,0-1.74,3.16v4.44c0,1.36.61,1.8,1.75,1.14a3.43,3.43,0,0,0,1.73-3.15v-2.71l-1.64.94v1.23l.54-.31v1.57a1.22,1.22,0,0,1-.6,1.18c-.37.21-.6.13-.61-.48v-4.61a1.25,1.25,0,0,1,.6-1.19c.37-.21.61-.12.61.49v.91l1.1-.63m-14.43,6.67v-1.21l-3.18,1.84,0,8.53,3.19-1.84v-1.22l-2,1.16v-2.5l1.6-.92v-1.22l-1.6.92v-2.38l2-1.16m-3.91,2.25v-1.21l-3.18,1.84,0,8.53,3.18-1.84v-1.21l-2,1.16v-2.5l1.6-.93V182.4l-1.61.93V181l2-1.17m9.59,1.8,0-8.53-1.17.67,0,8.53,1.16-.67",
    style: {
      fill: "#0E7490"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "195.33 155.44 195.09 155.9 190.25 165.09 183.8 177.34 178.4 172.45 181.56 171.61 183.63 172.9 189.73 163.02 192.91 157.87 194.58 156.19 195.33 155.44",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M188.37,163.13a1.33,1.33,0,0,1,1.36-.11l-6.1,9.88-2.07-1.29-3.16.84,5.4,4.89,6.45-12.25,0,8.44a4.1,4.1,0,0,1-1.86,3.23L180,181.63c-1,.59-1.87.12-1.88-1.07l0-9.32a4.07,4.07,0,0,1,1.86-3.23Z",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Character--inject-6"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M334.75,404.17c-.79,2.48-3.51,3.9-6.11,4.11s-5.16-.53-7.72-1c-5.74-1-11.27,0-17-.14a24.37,24.37,0,0,1-5.59-.61,9.28,9.28,0,0,1-4.78-2.82,6.21,6.21,0,0,1-1.37-3,5.89,5.89,0,0,0,1.37,4.67,9.28,9.28,0,0,0,4.78,2.82,24.36,24.36,0,0,0,5.59.6c5.73.14,11.26-.89,17,.15,2.56.46,5.13,1.19,7.72,1s5.32-1.63,6.11-4.11a6.57,6.57,0,0,0,.2-2.65A5.39,5.39,0,0,1,334.75,404.17Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M334.61,399.41c-.36-1.74-.71-3.47-1.06-5.21a7.94,7.94,0,0,0-.88-2.66,2.63,2.63,0,0,0-2.33-1.32c-3.14-.42-7.56-1.56-10.17.24a23.46,23.46,0,0,1-14.06,4.08c-2.59-.1-5.19-.63-7.77-.31s-5.26,1.75-6,4.23a5,5,0,0,0-.13,2.27,6.21,6.21,0,0,0,1.37,3,9.28,9.28,0,0,0,4.78,2.82,24.37,24.37,0,0,0,5.59.61c5.73.13,11.26-.9,17,.14,2.56.46,5.13,1.19,7.72,1s5.32-1.63,6.11-4.11a5.39,5.39,0,0,0,.2-1A12.22,12.22,0,0,0,334.61,399.41Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M319.41,385l-.23,6.79a2.71,2.71,0,0,0,2.5,2.78,43.41,43.41,0,0,0,6.85-.07,3.88,3.88,0,0,0,3.5-3.64l.27-5Z",
    style: {
      fill: "#ffa8a7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M363.76,381.38a5.22,5.22,0,0,1-.91,2.81,5.08,5.08,0,0,1-3.2,1.8,8.1,8.1,0,0,1-8-3.27c-.85-1.24-1.34-2.69-2.15-4a17.87,17.87,0,0,0-4.46-4.34,18.59,18.59,0,0,1-4.49-4.31,6.34,6.34,0,0,1-.86-5.74,3.67,3.67,0,0,0-.42.72,6.52,6.52,0,0,0,.8,6.12,19.37,19.37,0,0,0,4.59,4.44,18.41,18.41,0,0,1,4.55,4.47c.83,1.31,1.32,2.81,2.19,4.08a8.24,8.24,0,0,0,8.12,3.38,5.18,5.18,0,0,0,3.27-1.86,6.28,6.28,0,0,0,.95-3.9C363.78,381.67,363.77,381.53,363.76,381.38Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M361.7,372.86c-2.06-3.62-6.32-6.26-9.61-8.82a12.22,12.22,0,0,0-6.36-2.89,6,6,0,0,0-5.93,3,1.07,1.07,0,0,0-.07.19,6.34,6.34,0,0,0,.86,5.74,18.59,18.59,0,0,0,4.49,4.31,17.87,17.87,0,0,1,4.46,4.34c.81,1.27,1.3,2.72,2.15,4a8.1,8.1,0,0,0,8,3.27,5.08,5.08,0,0,0,3.2-1.8,5.22,5.22,0,0,0,.91-2.81,8,8,0,0,0,0-1A15.87,15.87,0,0,0,361.7,372.86Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M352.75,369.72v6.17a10.36,10.36,0,0,0,9.6-.42l.58-5.56Z",
    style: {
      fill: "#ffa8a7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M364.55,257.71c1.86,5.55-.42,31.94-1.5,57.26,4,9.56,2.93,36.73.62,56,0,0-4,2.47-11.27,0l-9.11-53.25L342,287.65s-2.29,26.7-4.91,43.83c2.47,13.12,1.85,15.59-4.24,55.94a15.2,15.2,0,0,1-13.66,0c-3.45-56.69-2.18-108.36-1.53-126.94Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M366.52,224.44l2.66,5.62-6.36,7,.46,16.73L383.81,236a5.54,5.54,0,0,0,1.36-6.6l-6.26-13Z",
    style: {
      fill: "#ffa8a7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M372.85,235.06s-2.88-2.38-3.67-5l-1.58,1.74A8.13,8.13,0,0,0,372.85,235.06Z",
    style: {
      fill: "#f28f8f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M366,225.79c8.15-.71,13.71-9.16,13.71-9.16-7.29-14.93-13.66-31.55-26.39-27.58Z",
    style: {
      fill: "#0E7490"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M316.59,215.11V262c27.63,11.57,45.53,1.12,48-4.32-1.27-19.1,3.24-41.44,2.9-50.94s-1.51-20.18-16.23-18l-15.65,1.53-7.94,1.93Z",
    style: {
      fill: "#0E7490"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M316.59,215.11V262c27.63,11.57,45.53,1.12,48-4.32-1.27-19.1,3.24-41.44,2.9-50.94s-1.51-20.18-16.23-18l-15.65,1.53-7.94,1.93Z",
    style: {
      fill: "#fff",
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M269.11,202.92a10.47,10.47,0,0,0,.83,1.76l17.44,29.21a8.3,8.3,0,0,0,12.63,2l11.1-9.86-11.26-12-5.64,5.86L278,199.16l-2.49-10.87a5.34,5.34,0,0,0-2.67-3.51l-6.9-3.71a1.35,1.35,0,0,0-1.61.24h0a1.36,1.36,0,0,0,.23,2.09l5,3.25L263,190.53a2.44,2.44,0,0,0-1.2,2.18l.07,3.15a2.67,2.67,0,0,0,2.43,2.6l1.08.1.25.66a6.68,6.68,0,0,0,3.46,3.7Z",
    style: {
      fill: "#ffa8a7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M290.76,227.09s.93-4.57,3.45-7.2l-1.55-2.06C291.49,220,289.83,224.21,290.76,227.09Z",
    style: {
      fill: "#f28f8f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M298.46,214.07l15.85-15.6a22.34,22.34,0,0,1,13-6.25l.29,0c6.71,14.7-2.16,21.88-2.16,21.88l-14.74,13.54A26.61,26.61,0,0,1,298.46,214.07Z",
    style: {
      fill: "#0E7490"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M326.28,153.75c-3.36-1.27-6.64-6.09-3.28-8.21.93-.7,3.66.11,5.86,0-1.93-1.74-2.39-3.82-1.42-4.48s3.54,1.82,8.23,1.35,20.84-5.67,22.86,6.14c2.26-3,4.75-.81,4.75-.81l-3.36,2.37c5,7,3.36,15.11-8.7,31.12a8.86,8.86,0,0,1-11.79,1.7l-5-12.27-4.86-5.91Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "325.16 163.56 321.92 169.19 325.47 170.5 325.16 163.56",
    style: {
      fill: "#f28f8f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M326.28,153.75a52.5,52.5,0,0,0-.94,23.94,8.29,8.29,0,0,0,1.49,3.79,5.92,5.92,0,0,0,4.12,1.89,17.59,17.59,0,0,0,4.62-.44v7.33c5.56,1.31,11.29,1.83,15.65-1.53v-7.5a19.93,19.93,0,0,1-9.72.61c-3.84-2.08-4.61-9.1-4.07-11a2.9,2.9,0,0,0,3,1.06,4.07,4.07,0,0,0,2.5-2,8.19,8.19,0,0,0,.93-3.12,5.68,5.68,0,0,0-.57-3.86,4,4,0,0,0-4.35-1.47,6.27,6.27,0,0,0-3.67,3.06,10,10,0,0,0-.64,1.41.87.87,0,0,1-1.69-.22,11.67,11.67,0,0,1,1.1-6.13,4.26,4.26,0,0,1-3.14-1.93,4,4,0,0,1-.6-3.52A12,12,0,0,1,326.28,153.75Z",
    style: {
      fill: "#ffa8a7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M342.8,306l-1-24.54c6.34,0,12.23-4.74,16.71-9.24-4.31,7.66-12.64,11.06-12.64,11.06Z",
    style: {
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M342.94,263c8.23-28.85,15.74-70.72,9.48-74.39h0a4.47,4.47,0,0,1,5.21-.33l.32.21c7.95,9.16-9.76,76.56-9.76,76.56Z",
    style: {
      fill: "#0E7490"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M342.94,263c8.23-28.85,15.74-70.72,9.48-74.39h0a4.47,4.47,0,0,1,5.21-.33l.32.21c7.95,9.16-9.76,76.56-9.76,76.56Z",
    style: {
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M349,264.57c.78,17.58-.79,32.48-9.3,36.06s-21.06-.67-25.76-2-13.55-5.93-15.68-9.07c-.78-8.62,2.13-17.13,4.14-19.93S349,264.57,349,264.57Z",
    style: {
      fill: "#0E7490"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M349,264.57c.78,17.58-.79,32.48-9.3,36.06s-21.06-.67-25.76-2-13.55-5.93-15.68-9.07c-.78-8.62,2.13-17.13,4.14-19.93S349,264.57,349,264.57Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M316.55,253.71c10.08,1.91,22.83,5.77,32.49,10.86-1.94,4.37-4.65,8.82-6.59,13.19a11.86,11.86,0,0,1-2.71,4.31c-2.22,1.93-5.49,1.94-8.42,1.65a65.8,65.8,0,0,1-23.56-7c-2.51-1.3-5.12-3-6-5.68-.69-2.23,0-4.64.88-6.8.57-1.41,1.23-2.94,2-4.47A10.91,10.91,0,0,1,316.55,253.71Z",
    style: {
      fill: "#0E7490"
    }
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMobilenotelistAmico);
export default __webpack_public_path__ + "static/media/Mobile note list-amico.8c6ba3767fa21724c980cb7936675240.svg";
export { ForwardRef as ReactComponent };